export default __webpack_public_path__ + "static/media/logo-sat.7a50a4b2.svg";